<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav :selectedLanguage="selectedLanguage" page="download" />

  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section id="downloadpage" style="height: auto !important">

        <section class="download-content">
          <div class="download-header">
            <h1><span v-html="t.title"></span></h1>
            <p class="header-desc"><span v-html="t.headerDesc"></span></p>
          </div>

          <div class="download-button-section">
            <button class="download-btn" @click="download()">
              <img src="@/assets/android.webp" alt="android icon">
              {{ t.downloadBtn }}
            </button>
            <p class="download-note">{{ t.versionNote }}</p>
          </div>

          <div class="app-info-section">
            <h2>{{ t.appInfoTitle }}</h2>
            <div class="app-info-table">
              <table>
                <tbody>
                  <tr><th>{{ t.appName }}</th><td>GBWhatsApp</td></tr>
                  <tr><th>{{ t.version }}</th><td>v18.80</td></tr>
                  <tr><th>{{ t.fileSize }}</th><td>85 MB</td></tr>
                  <tr><th>{{ t.releaseDate }}</th><td>{{ t.march2026 }}</td></tr>
                  <tr><th>{{ t.androidReq }}</th><td>Android 5.0+</td></tr>
                  <tr><th>{{ t.developer }}</th><td>GBWhatsApp Team</td></tr>
                  <tr><th>{{ t.price }}</th><td>{{ t.free }}</td></tr>
                  <tr><th>{{ t.license }}</th><td>{{ t.freeware }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="whatsapp-mods-section">
            <h2>{{ t.modsTitle }}</h2>
            <p>{{ t.modsIntro }}</p>
            <div class="mods-grid">
              <a :href="basePath + '/fmwhatsapp/'" class="mod-item">FMWhatsApp APK</a>
              <a :href="basePath + '/yowhatsapp/'" class="mod-item">YoWhatsApp APK</a>
              <a :href="basePath + '/whatsapp-plus/'" class="mod-item">WhatsApp Plus APK</a>
              <a :href="basePath + '/ogwhatsapp/'" class="mod-item">OGWhatsApp APK</a>
            </div>
          </div>

          <div class="features-section">
            <h2>{{ t.featuresTitle }}</h2>
            <ul>
              <li><strong>Improved Anti-Ban:</strong> Enhanced security to protect your account</li>
              <li><strong>New Themes:</strong> Added 50+ new custom themes</li>
              <li><strong>Privacy Plus:</strong> New ghost mode and advanced privacy options</li>
              <li><strong>Media Quality:</strong> Improved image and video sharing quality</li>
              <li><strong>Bug Fixes:</strong> Resolved issues from previous versions</li>
              <li><strong>Performance:</strong> Optimized app speed and stability</li>
            </ul>
          </div>

          <div class="download-instructions">
            <h2>{{ t.installTitle }}</h2>
            <ol>
              <li><strong>Backup Your Chats:</strong> Open WhatsApp, go to Settings > Chats > Chat Backup, and create a backup to Google Drive.</li>
              <li><strong>Enable Unknown Sources:</strong> Go to Settings > Security > Install unknown apps and enable for your file browser.</li>
              <li><strong>Download the APK:</strong> Click the download button above and save the file.</li>
              <li><strong>Install GBWhatsApp:</strong> Open the downloaded APK file and tap Install.</li>
              <li><strong>Verify Your Number:</strong> Open GBWhatsApp, enter your phone number, and verify via SMS.</li>
              <li><strong>Restore Chats:</strong> During setup, choose to restore your chat backup from Google Drive or local storage.</li>
            </ol>
          </div>

          <div class="requirements-section">
            <h2>{{ t.requirementsTitle }}</h2>
            <ul>
              <li>Android 5.0 (Lollipop) or higher</li>
              <li>At least 150MB free storage space</li>
              <li>Active phone number for verification</li>
              <li>Stable internet connection for download and verification</li>
            </ul>
          </div>

          <div class="faq-section">
            <h2>{{ t.faqTitle }}</h2>
            <div class="faq-item">
              <h3>{{ t.faq1Q }}</h3>
              <p>{{ t.faq1A }}</p>
            </div>
            <div class="faq-item">
              <h3>{{ t.faq2Q }}</h3>
              <p>{{ t.faq2A }}</p>
            </div>
            <div class="faq-item">
              <h3>{{ t.faq3Q }}</h3>
              <p>{{ t.faq3A }}</p>
            </div>
            <div class="faq-item">
              <h3>How often is GBWhatsApp updated?</h3>
              <p>GBWhatsApp is updated regularly, typically every 2-4 weeks, to add new features and fix bugs.</p>
            </div>
          </div>

          <div class="disclaimer-section">
            <h2>Disclaimer</h2>
            <p>GBWhatsApp is a modified version of WhatsApp and is not officially affiliated with WhatsApp Inc. Use at your own risk. We are not responsible for any account suspensions or data loss.</p>
          </div>

          <div class="download-button-section bottom">
            <button class="download-btn" @click="download()">
              <img src="@/assets/android.webp" alt="android icon">
              Download GBWhatsApp APK (85MB)
            </button>
          </div>

        </section>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import downloadTranslations from '@/i18n/download.js';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  components: {
    HeadNav,
  },
  computed: {
    locale() {
      const name = this.$route?.name || '';
      const lang = name.split('-')[0];
      return ['en', 'es', 'hi', 'pt', 'id'].includes(lang) ? lang : 'en';
    },
    selectedLanguage() {
      return this.locale;
    },
    t() {
      return downloadTranslations[this.locale] || downloadTranslations.en;
    },
    basePath() {
      const path = this.$route?.path || '';
      if (path.startsWith('/in')) return '/in';
      if (path.startsWith('/es')) return '/es';
      if (path.startsWith('/pt')) return '/pt';
      if (path.startsWith('/id')) return '/id';
      return '';
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=Outfit:wght@400;500;600;700;800&display=swap');

.download-content {
  max-width: 1080px;
  margin: 1rem auto;
  padding: 50px 30px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 30px rgba(45, 90, 39, 0.08);
}

.download-header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 4px;
    background: linear-gradient(90deg, transparent, #2d5a27, transparent);
    border-radius: 2px;
  }
}

.download-header h1 {
  color: #1a4d1b;
  font-family: 'Outfit', sans-serif;
  font-size: 2.8em;
  font-weight: 800;
  margin-bottom: 24px;
  line-height: 1.15;
  letter-spacing: -1px;
  background: linear-gradient(135deg, #1a4d1b 0%, #2d5a27 50%, #4a7c43 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 1.15em;
  color: #5a5a5a;
  margin-bottom: 30px;
  line-height: 1.7;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.download-image {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(45, 90, 39, 0.15), 0 0 0 1px rgba(45, 90, 39, 0.05);
  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 50px rgba(45, 90, 39, 0.2), 0 0 0 2px rgba(45, 90, 39, 0.1);
  }
}

.download-button-section {
  text-align: center;
  margin: 50px 0;
  padding: 40px 20px;
  background: linear-gradient(135deg, rgba(45, 90, 39, 0.04) 0%, rgba(74, 124, 67, 0.08) 100%);
  border-radius: 24px;
  border: 1px solid rgba(45, 90, 39, 0.1);

  &.bottom {
    margin-top: 60px;
    margin-bottom: 0;
  }
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: linear-gradient(135deg, #2d5a27 0%, #3d6b34 50%, #4a7c43 100%);
  color: white;
  border: none;
  padding: 24px 52px;
  border-radius: 20px;
  font-family: 'Outfit', sans-serif;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 8px 30px rgba(45, 90, 39, 0.35), 0 0 0 0 rgba(255,255,255,0.2);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: left 0.6s ease;
  }

  &::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background: rgba(255,255,255,0.3);
    border-radius: 50%;
    filter: blur(8px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s;
  }

  img {
    width: 28px;
    height: 28px;
    filter: brightness(0) invert(1);
  }

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 14px 45px rgba(45, 90, 39, 0.45), 0 0 0 3px rgba(45, 90, 39, 0.15);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-2px) scale(1.01);
  }
}

.download-note {
  margin-top: 20px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.95em;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,0.6);
  padding: 10px 20px;
  border-radius: 50px;
  backdrop-filter: blur(10px);
  
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    background: #4ade80;
    border-radius: 50%;
    animation: pulse 2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.6; transform: scale(1.3); }
  }
}

.app-info-section {
  margin: 50px 0;
}

.app-info-section h2, .whatsapp-mods-section h2, .features-section h2, 
.requirements-section h2, .faq-section h2, .disclaimer-section h2 {
  font-family: 'Outfit', sans-serif;
  color: #1a4d1b;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;
  position: relative;
  padding-bottom: 16px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #2d5a27, #4a7c43);
    border-radius: 2px;
  }
}

.app-info-table {
  background: linear-gradient(135deg, #f8faf8 0%, #f0f7f0 100%);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(45, 90, 39, 0.08);
  border: 1px solid rgba(45, 90, 39, 0.08);
}

.app-info-table table {
  width: 100%;
  border-collapse: collapse;
}

.app-info-table th,
.app-info-table td {
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.app-info-table th {
  background: #e9f7ef;
  color: #128C7E;
  font-weight: 600;
  width: 40%;
}

.app-info-table tr:last-child td,
.app-info-table tr:last-child th {
  border-bottom: none;
}

.whatsapp-mods-section {
  margin: 50px 0;
  background: linear-gradient(135deg, rgba(45, 90, 39, 0.04) 0%, rgba(74, 124, 67, 0.06) 100%);
  padding: 35px;
  border-radius: 20px;
  border: 1px solid rgba(45, 90, 39, 0.08);
}

.whatsapp-mods-section p {
  text-align: center;
  margin-bottom: 25px;
  color: #5a5a5a;
  font-size: 1.05em;
}

.mods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.mod-item {
  display: block;
  padding: 18px 20px;
  background: #fff;
  color: #1a4d1b;
  text-align: center;
  text-decoration: none;
  border-radius: 14px;
  font-weight: 600;
  font-family: 'Outfit', sans-serif;
  border: 2px solid rgba(45, 90, 39, 0.15);
  transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #2d5a27, #4a7c43);
    transform: scaleX(0);
    transition: transform 0.35s ease;
  }

  &:hover {
    background: linear-gradient(135deg, #2d5a27 0%, #3d6b34 100%);
    color: white;
    border-color: transparent;
    transform: translateY(-4px);
    box-shadow: 0 10px 30px rgba(45, 90, 39, 0.25);

    &::before {
      transform: scaleX(1);
    }
  }
}


.mod-item:hover {
  background: #25D366;
  color: white;
}

.features-section {
  margin: 50px 0;
}

.features-section ul {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
}

.features-section ul li {
  padding: 18px 0 18px 40px;
  position: relative;
  border-bottom: 1px solid rgba(45, 90, 39, 0.08);
  line-height: 1.6;
  font-size: 0.98em;
}

.features-section ul li::before {
  content: "✓";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #2d5a27;
  font-weight: bold;
  font-size: 1.1em;
  background: rgba(45, 90, 39, 0.1);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.download-instructions {
  margin: 50px 0;
}

.download-instructions h2 {
  color: #1a4d1b;
  font-family: 'Outfit', sans-serif;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;
  position: relative;
  padding-bottom: 16px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #2d5a27, #4a7c43);
    border-radius: 2px;
  }
}

.download-instructions ol {
  background: linear-gradient(135deg, rgba(45, 90, 39, 0.04) 0%, rgba(74, 124, 67, 0.06) 100%);
  padding: 35px 45px;
  border-radius: 16px;
  border-left: 4px solid #2d5a27;
}

.download-instructions li {
  margin-bottom: 18px;
  line-height: 1.7;
  font-size: 16px;
  font-family: 'DM Sans', sans-serif;

  strong {
    color: #2d5a27;
    font-weight: 600;
  }
}

.download-instructions li:last-child {
  margin-bottom: 0;
}

.requirements-section {
  margin: 50px 0;
}

.requirements-section ul {
  background: linear-gradient(135deg, rgba(45, 90, 39, 0.04) 0%, rgba(74, 124, 67, 0.06) 100%);
  padding: 30px 40px;
  border-radius: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
}

.requirements-section ul li {
  margin-bottom: 10px;
  line-height: 1.6;
  padding-left: 28px;
  position: relative;
  font-family: 'DM Sans', sans-serif;

  &::before {
    content: '•';
    position: absolute;
    left: 8px;
    color: #2d5a27;
    font-size: 1.4em;
  }
}

.faq-section {
  margin: 50px 0;
}

.faq-item {
  background: linear-gradient(135deg, #f8faf8 0%, #f0f7f0 100%);
  padding: 24px;
  border-radius: 14px;
  margin-bottom: 20px;
  border-left: 4px solid #2d5a27;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 20px rgba(45, 90, 39, 0.1);
    transform: translateX(4px);
  }
}

.faq-item h3 {
  color: #1a4d1b;
  font-family: 'Outfit', sans-serif;
  font-size: 1.1em;
  margin-bottom: 12px;
  font-weight: 600;
}

.faq-item p {
  line-height: 1.7;
  color: #5a5a5a;
  margin: 0;
  font-family: 'DM Sans', sans-serif;
}

.disclaimer-section {
  margin: 50px 0;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  padding: 24px;
  border-radius: 14px;
  border-left: 4px solid #f59e0b;
}

.disclaimer-section h2 {
  color: #92400e !important;
}

.disclaimer-section p {
  color: #92400e;
  line-height: 1.7;
  font-family: 'DM Sans', sans-serif;
}

@media (max-width: 768px) {
  .download-content {
    padding: 30px 20px;
    border-radius: 20px;
  }

  .download-header {
    margin-bottom: 35px;

    &::before {
      top: -20px;
      width: 80px;
    }

    h1 {
      font-size: 1.9em;
    }
  }

  .header-desc {
    font-size: 1em;
  }

  .download-button-section {
    padding: 30px 15px;
    margin: 35px 0;
    border-radius: 18px;
  }

  .download-btn {
    padding: 20px 36px;
    font-size: 17px;
    width: 100%;
    max-width: 320px;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .download-note {
    font-size: 0.85em;
  }

  .app-info-table {
    overflow-x: auto;
    display: block;
    -webkit-overflow-scrolling: touch;
  }

  .app-info-table th,
  .app-info-table td {
    padding: 12px 14px;
    font-size: 13px;
  }

  .download-instructions ol {
    padding: 24px 28px;
  }

  .download-instructions li {
    font-size: 14px;
    margin-bottom: 14px;
  }

  .mods-grid {
    grid-template-columns: 1fr;
  }

  .mod-item {
    padding: 16px;
  }

  .features-section ul {
    grid-template-columns: 1fr;
  }
}
</style>